import React from 'react'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'

import Overlay from '../components/Overlay'
import Form from '../components/ContacsForm'
import FormFund from '../components/ContacsFormFund'
import Link from './../components/Link'

/*const ContactsPage = ({ data, fetching, formOpened, setFormState }) => (
  <div>
    <div className='Contacts'>
      <div className='Container Container_light'>
        <h1 className='Head Contacts__title'>
          <FormattedMessage id='contacts.address' />
        </h1>
        <div className='Row Contacs__Row'>
          <div className='Contacts__col'>
            {data.email &&
              <div className='Contacts__row'>
                <p className='Text'>
                  <a href={`mailto:${data.email}`} className='Link Link_single'>{data.email}</a>
                  <a href={`tel:${data.phone}`} className='Link Link_single'>{data.phone}</a>
                </p>
              </div>
            }
            <div className='Contacts__row'>
              <p className='Text'>
                Если вы - компания и хотите включить благотворительную составляющую в свой бизнес, оставьте заявку, и мы 
                подберем наилучшие благотворительные механики для вас и ваших клиентов.
                <FormattedMessage id='contacts.we_are_on' />
                {' '}
                <a href={data.facebook} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.facebook' />
                </a>
                {', '}
                <a href={data.instagram} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.instagram' />
                </a>
                {' '}
                <FormattedMessage id='common.and' />
                &nbsp;
                <a href={data.youtube} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.youtube' />
                </a>
              </p>
            </div>
          </div>
          <div className='Contacts__col'>
            <p className='Text Contacts__text'>
              <FormattedMessage id='contacts.if_you_have' />
            </p>
            <button className='Button Button_white' onClick={e => setFormState(true)}>
              <FormattedMessage id='contacts.write' />
            </button>
          </div>
        </div>
      </div>
    </div>

    <Overlay isActive={formOpened} onClose={e => setFormState(false)}>
      <Form />
    </Overlay>
  </div>
)*/

const ContactsPage = ({ data, fetching, formOpened, setFormState, companyForm, setCompanyForm }) => (
  <div>
    <div className='Contacts'>
      <div className='Container'>{/*Container_light */}
        {/*<div className='Contacts__col'>*/}
        <div className='Row Contacts__row'>
          <div className='Contacts__col'>
            <p className='Text'>
              Если вы - <a className='Link Link_orange'>
                Компания
                </a> и хотите включить благотворительную составляющую в свой бизнес, оставьте заявку, и мы
                подберем наилучшие благотворительные механики для вас и ваших клиентов.
              </p>
          </div>
          <div className='Contacts__col'>
            <button className='Button Button_black' onClick={e => {setFormState(true), setCompanyForm(true)}}>
              Оставить заявку
            </button>
          </div>
        </div>
        <div className='Row Contacts__row'>
          <div className='Contacts__col'>
            <p className='Text'>
              Если вы - <a className='Link Link_orange'>
                Фонд
                </a> и мы можем помочь вам в сборе средств, оставьте заявку.
              </p>
          </div>
          <div className='Contacts__col'>
            <button className='Button Button_black' onClick={e => {setFormState(true), setCompanyForm(false)}}>
              Оставить заявку
            </button>
          </div>
        </div>
        <div className='Row Contacts__row'>
          <div className='Contacts__col'>
            <p className='Text'>
              Если вы - <a className='Link Link_orange'>
                Частное лицо
                </a>, и вы у нас на сайте, это значит,
              что вам интересны социальные проекты и вы поддерживаете
              идею осознанного потребления и помощи другим. На странице
              наших акций вы найдете предложения от неравнодушных брендов.
              </p>
          </div>
          <div className='Contacts__col'>
          <Link to="/actions">
            <button className='Button Button_black Contacts__button'>
              Посмотреть все акции
            </button>
            </Link>
          </div>
        </div>
        {/*</div>
          <div className='Contacts__col'>
            <button className='Button Button_white' onClick={e => setFormState(true)}>
              Оставить заявку
            </button>
          </div>*/}
      </div>
    </div>

    <Overlay isActive={formOpened} onClose={e => setFormState(false)}>
    {companyForm && <Form />}
    {!companyForm && <FormFund />}
    </Overlay>
  </div>
)

const mapStateToProps = state => ({
  ...state.contacts,
  currentLocale: state.intl.locale
})
export default compose(
  connect(mapStateToProps),
  withState('formOpened', 'setFormState', false),
  withState('companyForm', 'setCompanyForm', true)
)(ContactsPage)



// WEBPACK FOOTER //
// ./src/containers/Contacts.jsx